import { ViewNetTermsCTA } from "./ctas";
export var Net60BasicsIA = function Net60BasicsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return NET_60_TERMS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [NET_60_TERMS_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(_context) {
        return ViewNetTermsCTA(strictLocalize).label;
      },
      linkBuilder: function linkBuilder(_context) {
        var _ViewNetTermsCTA$getL, _ViewNetTermsCTA;
        return (_ViewNetTermsCTA$getL = (_ViewNetTermsCTA = ViewNetTermsCTA(strictLocalize)).getLink) === null || _ViewNetTermsCTA$getL === void 0 ? void 0 : _ViewNetTermsCTA$getL.call(_ViewNetTermsCTA);
      }
    }
  };
};
var NET_60_TERMS = function NET_60_TERMS(strictLocalize) {
  return strictLocalize({
    id: "ZLwdMl",
    defaultMessage: [{
      "type": 0,
      "value": "Sobre as condições de pagamento a 60 dias"
    }]
  });
};
var NET_60_TERMS_EXPLANATION = function NET_60_TERMS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DX76OY",
    defaultMessage: [{
      "type": 0,
      "value": "As condições de pagamento a 60 dias são uma opção de pagamento disponível na Faire, que lhe permite comprar novo inventário agora e pagar 60 dias depois. Oferecemos condições de pagamento a 60 dias para poder comprar a quantidade ideal de inventário para a sua loja enquanto gere o seu fluxo de caixa. Pode consultar o montante disponível das condições de pagamento clicando no botão abaixo ou ler o artigo do Centro de Ajuda para obter mais informações. Se precisar de mais ajuda, contacte-nos."
    }]
  });
};